import { AppState } from 'common/appState';

export const extractId = (_: AppState, id: number) => id;
export const extractRouteId = (_: AppState, props: { id: string }) => parseInt(props.id, 10);
export const extractRouteBenefitId = (_: AppState, props: { benefitId: string | number }) =>
    typeof props.benefitId != 'string' ? props.benefitId : parseInt(props.benefitId, 10);
export const extractRouteContractId = (_: AppState, props: { contractId: string | number }) =>
    typeof props.contractId != 'string' ? props.contractId : parseInt(props.contractId, 10);
